<template>
  <div class="container">
    <div class="index" v-if="!detail.show && !addShow">
      <div class="title">
        <span>{{ $route.name }} </span>
      </div>
      <div class="query">
        <el-form ref="form" :model="form" label-width="90px"> </el-form>
        <div class="query">
          <el-form ref="form" :inline="true" :model="form" label-width="90px">
            <el-form-item label="">
              <el-input
                v-model="form.name"
                clearable
                placeholder="请输入从业人员姓名"
              />
            </el-form-item>
            <el-form-item label="">
              <el-select
                v-model="form.status"
                placeholder="请选择账号状态"
                clearable
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" style="float: right">
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
              <el-button type="primary" size="small" @click="add"
                >创建从业人员</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <!-- <el-table-column
            align="center"
            prop="avatar"
            label="照片"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <img :src="scope.row.avatar['1']" style="height: 42px" alt="" />
            </template>
          </el-table-column> -->
          <el-table-column
            align="center"
            prop="name"
            label="人员姓名"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="account"
            label="账号/手机号"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.see">
                {{ scope.row.accountMsy }}
                <i
                  @click="see(scope.$index, scope.row)"
                  class="el-icon-view"
                  :style="{ color: '#409eff', cursor: 'pointer' }"
                ></i>
              </span>
              <span v-else>
                {{ scope.row.account | filtersAccount }}
                <i
                  @click="see(scope.$index, scope.row)"
                  class="el-icon-view"
                  :style="{ cursor: 'pointer' }"
                ></i>
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            align="center"
            prop="gender"
            label="性别"
            show-overflow-tooltip
          >
          <template slot-scope="scope">
              {{ scope.row.gender | genderFilter  }}
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            align="center"
            prop="country"
            label="国籍"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <!-- <el-table-column
            align="center"
            prop="employ_method"
            label="聘用方式"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <!-- <el-table-column
            align="center"
            prop="phone"
            label="联系方式"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <!-- <el-table-column
            align="center"
            prop="i"
            label="职业证书"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            align="center"
            prop="user_filing_status"
            label="教育部备案状态"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                :style="{
                  color: scope.row.user_filing_status == 5 ? 'green' : 'red',
                }"
              >
                {{ scope.row.user_filing_status | userFilingStatusFilter }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="账号状态"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.status | statusFilter }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.user_id)"
                >编辑</el-button
              >
              <!-- <el-button type="text" @click="setStatus(scope.row.user_id)">锁定</el-button>
              <el-button type="text" @click="HandleSetPassWord(scope.row.user_id)"
                >重置密码</el-button
              >
              <el-button type="text" style="color: red" @click="handerDel(scope.row.user_id)"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <!-- <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail> -->
    <Add
      :info="detail.info"
      v-show="addShow"
      :title="showTitle"
      @to-index="toIndex"
    ></Add>
    <el-dialog
      title="重置密码"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <el-input
        v-model="form.password"
        clearable
        placeholder="请重新输入密码"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setPassWord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrgMemberList,
  setUserStatus,
  delMember,
  updateMember,
  resetPassword,
  getUserMcyInfo,
  getOrgQYList,
  getMemberInfo,
  getAllUserList,
} from "@/api/user/userCenter";
export default {
  components: {
    // Detail: () => import("./details.vue"),
    Add: () => import("./add.vue"),
  },
  data() {
    return {
      form: {
        status: "",
        name: "",
        password: "",
        org_name: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      userId: "",
      tableData: [],
      currentPage: 4,
      detail: {
        info: {},
        show: false,
      },
      statusList: [
        { id: "0", label: "未激活  ", value: "0" },
        { id: "1", label: "正常    ", value: "1" },
        { id: "2", label: "注销    ", value: "2" },
        { id: "3", label: "锁定    ", value: "3" },
        { id: "4", label: "安管锁定", value: "4" },
        { id: "5", label: "空间封锁", value: "5" },
      ],
      addShow: false,
      centerDialogVisible: false,
      showTitle: "",
    };
  },
  mounted() {},
  created() {
    this.initData();
  },
  filters: {
    filtersAccount(str, num = 12) {
      if (!str) return "无";
      return str.substring(0, 2) + "****" + str.substring(str.length - 2);
    },
    statusFilter(type) {
      const typeMap = {
        0: "未激活   ",
        1: "正常    ",
        2: "注销    ",
        3: "锁定    ",
        4: "安管锁定",
        5: "空间封锁",
      };
      return typeMap[type];
    },
    userFilingStatusFilter(type) {
      const typeMap = {
        1: "人员不存在",
        2: "审核中",
        4: "审核不通过",
        5: "审核通过",
      };
      return typeMap[type] || "人员不存在";
    },
    genderFilter(type) {
      const typeMap = {
        0: "女",
        1: "男",
        2: "保密",
      };
      return typeMap[type];
    },
  },
  methods: {
    async initData() {
      //  let params = {
      //   top_org_id: sessionStorage.getItem("orgId")||'',
      //   org_id: sessionStorage.getItem("orgId")||'',
      //   org_recursion:'0',
      //   top_school_id: "",
      //   name: this.form.name,
      //   page: this.page.pageNum,
      //   page_size: this.page.pageSize,
      //   status:this.form.status, //用户状态(0:未激活, 1:正常, 2:注销, 3:锁定, 4:安管锁定,5空间封锁)，多个用”,”分割）
      // };
      //  console.log("机构获取在职人员列表---params----", params);
      // var { code, result } = await getOrgQYList(params);
      // console.log("机构获取在职人员列表---", code,result);
      // if (code == "000000") {
      //   this.tableData = result.member_list;
      //   this.page.totalPage = result.count;
      // }
      let params = {
        org_id: sessionStorage.getItem("orgId") || "",
        user_type: "", //  （user_type: 0:学生,1:教师,2:家长）不传时查平台所有用户类型
        keyword: this.form.name, //	名字模糊搜索
        province_code: "", //	省级code
        city_code: "", //	市级code
        area_code: "", //	区级code
        school_period: "", //  教师主教学段（0小学、1初中、2高中详见文档十三.9）
        subject_id: "", //	教师主教学科id
        page: this.page.pageNum, //  页码
        page_size: this.page.pageSize, //  每页条数，默认20，最大50
        order_by: "", //  1是按昨日空间访问量排序，0默认按访问量排序
        school_id: "", //	学校id，显示老师列表信息
        class_id: "", //	班级id，显示学生信息。与school_id两者传其一
        vocational_edu: "", //  是否查询职教的学校，1：是
        flag: "", //  标记(0:正常,1:演示,2:测试)
        platform_code: "", //	实体平台编码
        v_platform_code: "", //	虚拟平台编码
        badge: "", //	徽章代码，多个逗号分隔
        honorary_id: "", //	荣誉id
        console_admin_group_source: "", //	按区域管理角色
        system_id: "", //	体系id (1:省级培训讲师)
        role_id: "", //	角色id (默认角色岗位)
        period_type: "", //	学段类型字符串 多个以,连接
        status: this.form.status,
        org_name: this.form.org_name,
        // org_parent_ids: sessionStorage.getItem("orgId")||'', //	附属上级机构id(查的是所有的下级单位，包括跨行政级别的下级单位组织)
      };
      var { code, result } = await getAllUserList(params);
      if (code == "000000") {
        this.tableData = result.list;
        this.tableData.forEach((it) => {
          it.see = false;
        });
        console.log("获取书局---", this.tableData);
        this.page.totalPage = result.count;
      }
    },
    async see(index, row) {
      // this.$set(this.tableData, index, row);
      this.userId = row.user_id;
      this.tableData.forEach(async (it) => {
        if (it.user_id == row.user_id) {
          const { account } = await getUserMcyInfo({
            personId: row.user_id, //机构名称
            privacy: "0", //组织统一社会信用代码
          });
          if (it.see) {
            it.see = false;
          } else {
            it.see = true;
            it.accountMsy = account;
          }
          this.$set(this.tableData, index, it);
        }
      });
      
    },
    add() {
      this.addShow = true;
      this.showTitle = "新增人员";
      this.detail.info = {};
    },
    searchFun() {
      this.page.pageNum = 1;
      this.initData();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.initData();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.initData();
    },
    async edit(user_id) {
      this.addShow = true;
      this.showTitle = "编辑人员信息";
      this.detail.show = true;
      let paramsData = {
        user_id: user_id,
        top_org_id: sessionStorage.getItem("orgId"),
      };
      getMemberInfo(paramsData).then((res) => {
        console.log("用户中心获取用户信息----", res);
        if (res.code == "000000") {
          this.detail.info = res.result;
        }
      });
    },
    async setStatus(userId) {
      let params = {
        usession_id: sessionStorage.getItem("usessionid"), //	否	string	学年学期
        user_id: userId,
        status: "3", //0:未激活, 1:正常, 2:注销, 3:成员锁定, 4:安管锁定,5:空间封锁）
      };
      var { code, message } = await setUserStatus(params);
      if (code == "000000") {
        this.page.pageNum = 1;
        this.initData();
        this.$message({
          type: "success",
          message: "操作成功",
        });
      } else {
        this.$message({
          type: "error",
          message: message,
        });
      }
    },
    HandleSetPassWord(userId) {
      this.centerDialogVisible = true;
      this.userId = userId;
    },
    async setPassWord(userId) {
      let params = {
        usession_id: sessionStorage.getItem("usessionid"), //	否	string	学年学期
        user_id: this.userId,
        top_org_id: sessionStorage.getItem("orgId"),
        type: "1", //	成员的类型(1部门用户，2学生用户)，默认1
        password: this.form.password,
      };
      var { code, message } = await resetPassword(params);
      if (code == "000000") {
        this.centerDialogVisible = false;
        this.page.pageNum = 1;
        this.initData();
        this.$message({
          type: "success",
          message: "重置密码成功",
        });
      } else {
        this.$message({
          type: "error",
          message: message,
        });
      }
    },
    async handerDel(userId) {
      let params = {
        usession_id: sessionStorage.getItem("usessionid"), //	否	string	学年学期
        top_org_id: sessionStorage.getItem("orgId"),
        target_user_ids: userId,
      };
      var { code, message } = await delMember(params);
      if (code == "000000") {
        this.page.pageNum = 1;
        this.initData();
        this.$message({
          type: "success",
          message: "操作成功",
        });
      } else {
        this.$message({
          type: "error",
          message: message,
        });
      }
    },
    toIndex() {
      this.detail.show = false;
      this.addShow = false;
      this.page.pageNum = 1;
      this.initData();
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 170px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
</style>
